import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAsyncThunk } from '@reduxjs/toolkit';
import { TARIFF_TYPES } from '@fttb/common';
import { ADDRESS_PARAMS_DATA } from "../../../../../store/constants";
import { AVAILABLE_STATUSES, POPUP_CONNECTION_STATE, popupSteps } from "../../../../../store/common/constants";
import { submitCallbackRequest } from "../../../../../store/callbackRequest/actions/submitCallbackRequest";
import { buildOrderQueryParams, getConnectionStatus, getTargetTariffType, selectActionHref } from "../selectors/orderTariffCommon";
import { setAddressViewValue } from "./common";
import { getCurrentFormStep } from "../selectors/modal";
import { resetOrderTariffData } from "./resetOrderTariffData";
import { ymOrderTariffAddressView } from "../../analytics";
export var handleOrderStepsProgress = createAsyncThunk('handleOrderStepsProgress', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(connectionData, _ref) {
    var dispatch, getState, state, userAddressData, currentStep, tariffData, actionHref, connectionState, isPresetUp, ymEventName, newUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dispatch = _ref.dispatch, getState = _ref.getState;
          dispatch(setAddressViewValue(true));
          state = getState();
          userAddressData = buildOrderQueryParams(state);
          currentStep = getCurrentFormStep(state);
          tariffData = getTargetTariffType(state);
          actionHref = selectActionHref(state);
          connectionState = getConnectionStatus(state);
          if (!(currentStep === popupSteps.addressRequestForm)) {
            _context.next = 16;
            break;
          }
          isPresetUp = tariffData.tariffType === TARIFF_TYPES.presetUp;
          ymEventName = isPresetUp ? 'fmc_address_continue' : 'address_continue';
          ymOrderTariffAddressView(ymEventName, tariffData.tariffType);
          if (!(connectionState === POPUP_CONNECTION_STATE.isExists || connectionState === POPUP_CONNECTION_STATE.alreadyInUse)) {
            _context.next = 16;
            break;
          }
          _context.next = 15;
          return dispatch(submitCallbackRequest());
        case 15:
          return _context.abrupt("return");
        case 16:
          if (currentStep === popupSteps.addressNotAvailableModal) {
            window.location.replace(actionHref);
          }
          if (AVAILABLE_STATUSES.includes(connectionState)) {
            sessionStorage.setItem(ADDRESS_PARAMS_DATA, userAddressData);
            newUrl = "".concat(tariffData.tariffUrl, "?").concat(userAddressData);
            window.location.assign(newUrl);
          }
          dispatch(resetOrderTariffData());
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());